import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import { LocationData } from "types/models/master/MasterApp";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";


interface LocationTableProps {
  location: LocationData[];
}

const LocationTable: React.FC<LocationTableProps> = ({location}) => {
  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading />
        </TableHead>
        <TableBody>
          {location.map((data) => (
            <TableItem data={data} key={data.id} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default LocationTable;
